<template>
  <div class="flex flex-col min-h-screen items-center">
    <div class="flex justify-between items-center w-full max-w-[1280px]">
      <div class="ml-4 sm:ml-0">
        <LogoIcon />
      </div>
      <div class="h-12 mt-5 mb-5 mr-4 sm:mr-8">
        <LanguageSwitch />
      </div>
    </div>
    <div class="max-w-[483px] w-full text-center flex-grow px-4">
      <h2 class="my-6 text-center">
        {{ $t('messages.oauth_error.title') }}
      </h2>
      <div class="bg-white rounded-lg">
        <div class="mb-6 flex flex-col items-center flex-shrink-0 text-center">
          <div class="mt-6 mb-4">
            <svg class="w-16 h-16 text-red-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
            </svg>
          </div>
          <p class="b1 text-zyxel-gray-900">
            <strong>{{ errorTitle }}</strong>
          </p>
        </div>
        <p class="b1 block text-left text-zyxel-gray-800 ml-6 mr-6 mb-6">
          {{ errorDescription }}
        </p>
        <div class="ml-6 mr-6 mb-6 p-4 bg-yellow-50 border border-yellow-200 rounded-lg">
          <p class="b2 text-zyxel-gray-900 font-bold mb-2">
            {{ $t('messages.oauth_error.not_your_fault') }}
          </p>
          <p class="b2 text-zyxel-gray-800">
            {{ $t('messages.oauth_error.contact_app_developer') }}
          </p>
        </div>
        <div class="ml-6 mr-6 mb-6 pb-6">
          <button
            class="btn-primary w-full"
            @click="goToSignIn"
          >
            {{ $t('messages.oauth_error.back_to_signin') }}
          </button>
        </div>
      </div>
    </div>
    <ZyxelFooter />
  </div>
</template>

<script>
import { ref, computed } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { useI18n } from 'vue-i18n';
import LogoIcon from '@/components/LogoIcon.vue';
import LanguageSwitch from "@/components/LanguageSwitch.vue";
import ZyxelFooter from "@/components/ZyxelFooter.vue";

export default {
  name: 'OAuthErrorPage',
  components: {
    LogoIcon,
    LanguageSwitch,
    ZyxelFooter,
  },
  setup() {
    const route = useRoute();
    const router = useRouter();
    const { t } = useI18n();

    const errorCode = ref(route.query.error_code || 'unknown');

    const errorTitle = computed(() => {
      const titles = {
        'invalid_client': t('messages.oauth_error.invalid_client.title'),
        'invalid_redirect_uri': t('messages.oauth_error.invalid_redirect_uri.title'),
        'unknown': t('messages.oauth_error.unknown.title')
      };
      return titles[errorCode.value] || titles['unknown'];
    });

    const errorDescription = computed(() => {
      const descriptions = {
        'invalid_client': t('messages.oauth_error.invalid_client.description'),
        'invalid_redirect_uri': t('messages.oauth_error.invalid_redirect_uri.description'),
        'unknown': t('messages.oauth_error.unknown.description')
      };
      return descriptions[errorCode.value] || descriptions['unknown'];
    });

    const goToSignIn = () => {
      router.push({ name: 'SignIn' });
    };

    return {
      errorCode,
      errorTitle,
      errorDescription,
      goToSignIn
    };
  }
}
</script>
